import 'preact/debug';
// import 'ts-polyfill';
// import { ValidationService } from 'aspnet-validation';
import 'core-js/stable';
import { ValidationService } from '../../functions/aspnet-validation';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
// import { CaptureConsole } from '@sentry/integrations';

export interface UserWindow extends Window {
  userId?: string;
  userEmail?: string;
}
declare let window: UserWindow;
const { hostname } = window.location;

let environment = 'production';

if (hostname.includes('coldbanana.tech')) {
  environment = 'staging';
} else if (hostname.includes('localhost')) {
  environment = 'development';
}

if (window.userId || window.userEmail) {
  const user: any = {};
  if (window.userId) {
    user.id = window.userId;
  }
  if (window.userEmail) {
    user.email = window.userEmail;
  }
  Sentry.setUser(user);
}

Sentry.init({
  release: 'fargro-frontend@{{FE_VERSION}}',
  dsn: 'https://fe48d724e9d74635870658a999287244@o207017.ingest.sentry.io/5872467',
  integrations: [
    new Integrations.BrowserTracing(),
    // new CaptureConsole({
    //   levels: ['warn', 'error', 'debug', 'assert'],
    // }) as any,
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  environment,
  tracesSampler: (samplingContext) => {
    // Examine provided context data (including parent decision, if any) along
    // with anything in the global namespace to compute the sample rate or
    // sampling decision for this transaction

    if (environment === 'production') {
      // Default sample rate
      return 0.5;
    } else {
      // These are important - take a big sample
      return 1;
    }
  },
  beforeSend: function (event, hint) {
    // filter out UnhandledRejection errors that have no information
    if (
      event !== undefined &&
      event.exception !== undefined &&
      event.exception.values !== undefined &&
      event.exception.values.length == 1
    ) {
      var e = event.exception.values[0];
      if (e.type === 'UnhandledRejection' && e.value === 'Non-Error promise rejection captured with value: ') {
        return null;
      }
    }
    return event;
  },
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    'Script error.',
    // Avast extension error
    '_avast_submit',
  ],
  denyUrls: [
    // Google Adsense
    /pagead\/js/i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    // Mouseflow flakiness
    /mouseflow\.com/i,
    /o2\.mouseflow\.com/i,
    /cdn\.mouseflow\.com/i,
  ],
});

(function () {
  try {
    // Bootstrap AspNet validation
    const v = new ValidationService();
    v.bootstrap();
  } catch (e) {
    console.warn(e);
  }
})();
